import { CategoriaNode, PaginaNode } from '@gql/graphql'
import { useTrans } from 'hooks'
import {
  EffettiSection,
  GenericHero,
  ListingExplorer,
  MagazineSection,
  Page,
  Prefooter,
} from 'components/organisms'
import styles from './ListingTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
  listing?: any //
  categoria?: CategoriaNode
}

const ListingTemplate = (props: Props) => {
  const { pagina = undefined, listing = undefined, categoria = undefined } = props

  const t = useTrans()

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <GenericHero
          pagina={{
            titolo: categoria.title,
            descrizione: categoria.abstract,
            breadcrumbs: pagina.breadcrumbs,
          }}
        />
        <ListingExplorer listing={listing} categoria={categoria} />
        <MagazineSection
          magazines={listing.ispirazioni}
          item={{
            name: t('Ispirazioni'),
            ctaLabel: t('Scopri tutte le ispirazioni'),
          }}
        />
        <EffettiSection
          effetti={listing?.effetti}
          item={{
            name: t('Effetti per ogni ambiente e gusto estetico'),
          }}
        />
        <Prefooter />
      </main>
    </Page>
  )
}

export default ListingTemplate
